"use strict";
exports.__esModule = true;
exports.retrieveUsingLookup = void 0;
function retrieveUsingLookup(schemas) {
    return function (uri) {
        return schemas[uri];
    };
}
exports.retrieveUsingLookup = retrieveUsingLookup;
